import { css } from 'lit';

export const clusterCss = css`
  .cluster {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-xs);
  }

  .cluster--space-between {
    justify-content: space-between;
  }

  .cluster--flex-end {
    justify-content: flex-end;
  }
`;
